import { AibleClientFactory } from "../../client/aible/factory";
import { toast } from "react-toastify";
function download_notebook(target_name, target_blob) {
    const blobsURL = window.URL.createObjectURL(target_blob);
    const a = document.createElement("a");
    a.href = blobsURL;
    a.setAttribute("download", target_name);
    document.body.appendChild(a);
    a.click();
    a.remove();
}
function toasty(message, toast_type) {
    toast(message, {
        type: toast_type,
        position: toast.POSITION.TOP_CENTER,
        autoClose: 7500
    });
}
function angry_toast(message, details) {
    toasty(message, toast.TYPE.ERROR);
    throw new Error(details || message);
}
export const getErrorNotebook = async (accountId, notebookId) => {
    const accountClient = AibleClientFactory.getInstance().getAccountClient();
    const account = await accountClient.getAccount(accountId);
    const factory = await accountClient.getCustomerClientFactory(accountId);
    const cloudDatasetClient = factory.getDatasetClient();
    const notebookResponse = await cloudDatasetClient.getErrorNotebookUrls(notebookId);
    if (notebookResponse.type === "notebook-error") {
        console.log("Failed to get dataset notebook: ", notebookResponse.message);
        angry_toast("We could not retrieve the error report.", notebookResponse.message);
    }
    else {
        Object.values(notebookResponse.notebooks).map(async (nbSuccess) => {
            const res = await accountClient.presignedGetRequest(account, nbSuccess.url, nbSuccess.name);
            await res.downloadFile();
        });
    }
};
